import isPropValid from "@emotion/is-prop-valid";
import * as React from "react";
import type { VisuallyHiddenProps } from "./VisuallyHiddenStyled";

const mergeClassNames = (...classes: Array<string | undefined>) =>
  classes.filter(Boolean).join(" ");

export const VisuallyHiddenTailwind = ({
  as,
  children,
  className,
  ...rest
}: VisuallyHiddenProps) => {
  const Element = (as ?? "span") as React.ElementType;
  const forwardedProps =
    typeof Element === "string"
      ? Object.fromEntries(
          Object.entries(rest).filter(([name]) => isPropValid(name))
        )
      : rest;

  return React.createElement(
    Element,
    {
      ...forwardedProps,
      className: mergeClassNames("seeds-visually-hidden", className),
    },
    children
  );
};

VisuallyHiddenTailwind.displayName = "VisuallyHiddenTailwind";
